// ==================== CUSTOM UI COMPONENTS ====================

import React from 'react';
import { Box } from '@mui/material';
import { useTheme } from '../../contexts/ThemeContext';

const GradientBox = ({
  children,
  gradient = 'primary',
  glass = false,
  sx = {},
  ...props
}) => {
  const { colors, glassmorphism, isDarkMode } = useTheme();

  const getBackground = () => {
    if (glass) {
      return isDarkMode ? glassmorphism.dark : glassmorphism.light;
    }
    return colors[gradient]?.gradient || colors.primary.gradient;
  };

  return (
    <Box
      sx={{
        background: getBackground().background || getBackground(),
        backdropFilter: glass ? 'blur(10px)' : 'none',
        border: glass ? getBackground().border : 'none',
        borderRadius: 2,
        ...sx,
      }}
      {...props}
    >
      {children}
    </Box>
  );
};

export default GradientBox;
